module Meevo.Plugins.EmployeeTemplates {
    "use strict";

    /**
    * Location Section of Employee Template
    */
    export class TemplateServiceSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.EmployeeTemplate> {
        COLOR_STANDARD: string = "white";
        COLOR_REVERT: string = "#E4E410";
        protected securityChecker: Meevo.Components.Common.ISecurityService;

        private securityKeys = Meevo.Components.Common.SecurityKeys;
        private numberOfPriceLevelsToDisplay;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Components.Logging.ILoggingService,
            dataService: Components.BaseClasses.IDataService,
            identityService: Components.Common.IIdentityService = null,
            noun: Model.NounEnum = null,
            appSettings: Components.Common.IAppSettings,
            sectionSecurityKey?: string,
            securityChecker?: Meevo.Components.Common.ISecurityService) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, appSettings, sectionSecurityKey);
            this.securityChecker = securityChecker;
            this.getServicePriceLevels();
            
        }

        getServicePriceLevels(): angular.IPromise<Meevo.Model.RegisterSettings> {
            return this.dataService.customMethodData('/api/Settings/Register', 'GET', null).then((response) => {
                this.numberOfPriceLevelsToDisplay = response.data.defaultPriceLevelsForService;
                return response;
            });
        }

        setServicePriceLevels(item?: any): void {
            let priceLevelsForService = angular.copy(item.priceLevelSelection);
            let lastPriceLevelWithValue = _.findIndex(priceLevelsForService.reverse(), (pl: any) => { return pl.price !== 0 });

            let numberOfPriceLevelsWithValue = lastPriceLevelWithValue > 0 ? item.priceLevelSelection.length - lastPriceLevelWithValue : lastPriceLevelWithValue;
            this.numberOfPriceLevelsToDisplay = numberOfPriceLevelsWithValue > this.numberOfPriceLevelsToDisplay ? numberOfPriceLevelsWithValue : this.numberOfPriceLevelsToDisplay;
        }

        showPriceLevel(index): boolean {
            let show = index < this.numberOfPriceLevelsToDisplay;
            return show;
        }

        get minuteSelection(): any {
            return _.range(0, 735, 15);
        }
        myStyle: any;
        toggleCanPerform(item: any): boolean {
            if (!item.doesNotPerform) {
                item.expandItem = true;
                if (!this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEETEMPLATE_TAB_SERVICES_ACTION_EXPAND))
                    item.expandItem = false;
                // Initialize price level selection
                if (Model.Guard.isNothing(item.priceLevel)) {
                    const priceLevel: any = _.first(item.priceLevelSelection);
                    item.priceLevel = priceLevel.id;
                    item.price = priceLevel.price;
                };
                return true;
            }
            else {
                item.expandItem = false;
                return false;
            }
        }

        toggleExpandItem(item: any): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys
                .DATA_EMPLOYEETEMPLATE_TAB_SERVICES_ACTION_EXPAND)) {
                if (Model.Guard.isNothing(item.priceLevel)) {
                    const priceLevel: any = _.first(item.priceLevelSelection);
                    item.priceLevel = priceLevel.id;
                    item.price = priceLevel.price;
                }
                item.expandItem = !item.expandItem
            }
        }

        toggledAllItems(items: any, value?: boolean): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEETEMPLATE_TAB_SERVICES_ACTION_EXPAND))
                _.map(items,
                    (i: any) => {
                        i.expandItem = value;
                    });

        }

        updateNewPrice(priceLevel: any, priceLevelSelection: any, item): void {
            let newValue: any = _.findWhere(priceLevelSelection, { id: priceLevel }) // find in array where the new price level from select matches level selections
            if (newValue) {
                item.price = newValue.price;
                item.priceRevertTo = newValue.price;
            }
        }

        updatePriceRevertTo(item: any): void {
            this.updateNewPrice(item.priceLevel, item.priceLevelSelection, item);
            item.isPriceOverriden = false;
        }

        getPriceBackgroundColor(item: any): any {
            return this.showPriceRevertTo(item) ? this.COLOR_REVERT : this.COLOR_STANDARD;
        }

        showPriceRevertTo(item: any): boolean {
            if ((item.priceRevertTo && item.price != item.priceRevertTo) || item.isPriceOverriden) {
                item.isPriceOverriden = true;
                return true;
            }
            return false;
        }

        onBlurOfPrice(item: any): any {
            if (!item.isPriceOverriden && item.price != item.priceRevertTo) {
                item.isPriceOverriden = true;
            }
            console.log("Price changed : " + item);
        }

        updateMinutesRevertTo(step: any): void {
            step.minutes = step.minutesRevertTo;
            step.isMinutesOverriden = false;
        }

        showStepRevertTo(step: any): boolean {
            if(step.minutes != step.minutesRevertTo || step.isMinutesOverriden) {
                step.isMinutesOverriden = true;
                return true;
            }
            return false;
        }

        toggleEditServiceSteps(isEditing: boolean, item: any): void {
            if (!isEditing) return;
            item.isEditable = true;
        }
    }
}